import React, { useState } from 'react';
import "./ContactMe.css";
import emailjs from '@emailjs/browser';

const ContactMe = () => {
    
    const [formData, setFormData] = useState({
        user_name: '',
        user_email: '',
        subject: '',
        message: ''
    });
    const [showAlert, setShowAlert] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const sendEmail = (e) => {
        e.preventDefault();

        const emailData = {
            to_name: formData.user_name,
            from_name: formData.user_email,
            message: formData.message,
            publicKey: 'mt87IpaKoJt1ILW4q'
        };

        emailjs.sendForm('service_y3hjsg2', 'template_fyw0ft9', e.target, emailData)
            .then(
                () => {
                    console.log('SUCCESS! Email sent successfully');
                    setFormData({
                        user_name: '',
                        user_email: '',
                        subject: '',
                        message: ''
                    });
                    setShowAlert(true);
                    setTimeout(() => setShowAlert(false), 3000);
                },
                (error) => {
                    console.error('FAILED...', error.text);
                }
            );
    };

    return (
        <section id='contact'>
            <div className='container'>
                <div className='ContectMe'>
                    <div className='addressSection'>
                        <div className='FormHadding'>
                            <h2 className='FormHaddingText'>Contact Us</h2>
                            <p>Let's make something creative! Amazing design just for you.</p>
                        </div>
                        <div className='formInfo'>
                            <div className='formItem'>
                                <h5>EMAIL</h5>
                                <a href="mailto:nazmulrdo@gmail.com">nazmulrdo@gmail.com</a>
                            </div>
                            <div className='formItem'>
                                <h5>Phone</h5>
                                <a href="tel:01636852859">01636852859</a>
                            </div>
                        </div>
                    </div>
                    <div className='formSecion'>
                        <h5>I craft awesome design solutions for you. Let’s message me and make <span>something together!</span></h5>
                       
                        <form className='contactFrom' onSubmit={sendEmail}>
                        <input type="text" placeholder='Full Name' name="user_name" value={formData.user_name} onChange={handleChange} required /><br />
                        <input type="email" placeholder='Email' name='user_email' value={formData.user_email} onChange={handleChange} required /><br />
                        <input type="text" placeholder='Subject' name='subject' value={formData.subject} onChange={handleChange} required /><br />
                        <textarea name='message' value={formData.message} onChange={handleChange} cols="30" rows="10"></textarea><br />
                        <button type='submit' value="Send" className='formBtn'><span>{showAlert? "Message sent successfully!": "Send Message"}</span></button>
                        {/* {showAlert && <div className='alert'></div>} */}
                    </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactMe;